import http from './http';

export default {
  all() {
    return http().get(`/v1/scheduled_contacts/`);
  },
  allIncomplete() {
    return http().get(`/v1/scheduled_contacts/?is_complete=*false`);
  },
  allForRecord(record_id) {
    return http().get(`/v1/scheduled_contacts/?record_id=${record_id}`);
  },
  get(id) {
    return http().get(`/v1/scheduled_contacts/${id}`);
  },
  create (data) {
    return http().post(`/v1/scheduled_contacts`, data);
  },
  update (data) {
    return http().put(`/v1/scheduled_contacts/${data.id}`, data);
  },
  delete(id) {
    return http().delete(`/v1/scheduled_contacts/${id}`);
  },
  setComplete(data) {
    return http().put(`/v1/scheduled_contacts/${data.id}/set_complete`, data);
  }
}
